import { useSelector } from "react-redux";
import { FloatPanel } from "../../../../../components/floatPanel";
import { CatalogEditor } from "./reference";
import "./reference.css";
export const Edition = () => {
  const panel = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel,
  );
  return (
    <FloatPanel
      className="catalogReferencePanel"
      template={<CatalogEditor key={`${panel.queryId}-${panel.isEmpty}`} />}
    />
  );
};
